export const spawnNewWindow = (url: string) => {
	return window.open(url, '_blank');
};

export default spawnNewWindow;
